import apiClient from '../client';
import type { Role, RolePermission } from '@/types';

export interface MyPermissionsResponse {
  role: string;
  permissions: string[];
}

export const rbacApi = {
  /** Fetch the current user's role and resolved permissions */
  getMyPermissions: () =>
    apiClient.get<{ data: MyPermissionsResponse }>('/rbac/my-permissions').then((r) => r.data.data),

  listRoles: () => apiClient.get<{ data: Role[] }>('/rbac/roles').then((r) => r.data.data),

  createRole: (payload: { name: string; description?: string }) =>
    apiClient.post<{ data: Role }>('/rbac/roles', payload).then((r) => r.data.data),

  updateRole: (id: number, payload: { name: string; description?: string }) =>
    apiClient.put<{ data: Role }>(`/rbac/roles/${id}`, payload).then((r) => r.data.data),

  deleteRole: (id: number) => apiClient.delete(`/rbac/roles/${id}`),

  listRolePermissions: (roleName: string) =>
    apiClient.get<{ data: RolePermission[] }>(`/rbac/role-permissions/${roleName}`).then((r) => r.data.data),

  bulkSetPermissions: (roleName: string, permissions: string[]) =>
    apiClient.put<{ data: RolePermission[] }>(`/rbac/role-permissions/${roleName}`, { permissions }).then((r) => r.data.data),
};
